export const videoPlayersTypes = [
    "youtube",
    "vimeo",
    "iframe"
]